import { Persistent } from './persistent.model';

export class TipoAttributoEntity extends Persistent   {

  constructor(public id: number,
              public nome: string,
              public descr: string,
              public tipodati: string) {
    super(id);
  }

  public getLabel() {
    return this.nome;
  }

}
